import { NgModule } from '@angular/core';
import { SearchFieldComponent } from './search-field.component';

@NgModule({
  imports: [SearchFieldComponent],
  exports: [SearchFieldComponent],
})
export class SearchFieldModule {}
